import React from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";
import { Link } from "react-router-dom";

function Contact() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="contact page">
      <Header />

      <div className="contact__wrap">
        <nav className="breadcrumb">
          <Link onClick={toTop} to="/">
            Home
          </Link>
          <span className="crumb-sep">&lt;</span>
          <Link onClick={toTop} to="#">
            Customer Service
          </Link>
          <span className="crumb-sep">&lt;</span>
          <span>Contact Us</span>
        </nav>

        <header className="contact__header">
          <h1 className="contact__title">CONTACT US</h1>
          <hr className="contact__rule" />
          <p className="contact__lead">
            Our Customer Service Is Handcrafted, Too.
          </p>
        </header>

        <section className="contact__grid container">
          <div className="contact__col contact__col--left">
            <div className="contact__section">
              <h3>FOR HANDCRAFTED SOLUTIONS:</h3>
              <p>
                Call customer service at{" "}
                <Link onClick={toTop} to="tel:8884011900">
                  888-401-1900
                </Link>
              </p>
            </div>

            <div className="contact__section">
              <h3>SALES &amp; CUSTOMER SERVICE</h3>
              <p>
                2550 NW Nicolai St
                <br />
                Portland, OR, 97210
              </p>
            </div>

            <div className="contact__section">
              <h3>DESIGN SERVICES</h3>
              <p>
                Our Design Experts are here to help via phone at{" "}
                <Link onClick={toTop} to="tel:8667860002">
                  866-786-0002
                </Link>
              </p>
            </div>
          </div>

          <div className="contact__col contact__col--right">
            <div className="store">
              <h4 className="store__title">EDINA STORE</h4>
              <p className="store__addr">
                3670 Galleria
                <br />
                Edina, MN 55435
              </p>
              <p>
                <Link onClick={toTop} to="tel:9522856865">
                  952-285-6865
                </Link>
              </p>
              <p>
                <Link onClick={toTop} to="mailto:qty@retteve.store">
                  qty@retteve.store
                </Link>
              </p>
            </div>

            <div className="store">
              <h4 className="store__title">ATLANTA STORE</h4>
              <p className="store__addr">
                675 Ponce De Leon Ave NE Suite E180
                <br />
                Atlanta, GA 30308
              </p>
              <p>
                <Link onClick={toTop} to="tel:4048726719">
                  404-872-6719
                </Link>
              </p>
              <p>
                <Link onClick={toTop} to="mailto:qty@retteve.store">
                  qty@retteve.store
                </Link>
              </p>
            </div>

            <div className="store">
              <h4 className="store__title">PORTLAND STORE</h4>
              <p className="store__addr">
                2550 NW Nicolai St
                <br />
                Portland, OR 97210
              </p>
              <p>
                <Link onClick={toTop} to="tel:5035551234">
                  503-555-1234
                </Link>
              </p>
              <p>
                <Link onClick={toTop} to="mailto:qty@retteve.store">
                  qty@retteve.store
                </Link>
              </p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
